﻿import { buildFetchUrl } from "../utils/toolHelper";


function init() {
    var pemBox = document.getElementById("pem-box") as HTMLTextAreaElement;
    var pemDecodeButton = document.getElementById("pem-decode") as HTMLButtonElement;
    pemBox.placeholder = "-----BEGIN CERTIFICATE-----\nPaste your PEM encoded certificate text here\n-----END CERTIFICATE-----";

    pemBox.addEventListener("keyup", () => {
        if (isPemFormattedString(pemBox.value)) {
            pemDecodeButton.disabled = false;
        }
        else {
            pemDecodeButton.disabled = true;
        }
    })

    pemBox.addEventListener('paste', e => {
        e.preventDefault();
        const text = (e.clipboardData || (window as any).clipboardData).getData('text');
        const clean = text.replace(/\\n/g, '\n');
        const start = pemBox.selectionStart;
        const end = pemBox.selectionEnd;
        pemBox.setRangeText(clean, start, end, 'end');
    });

    pemDecodeButton.addEventListener('click', e => decodePem(e, urlDecodeButton, pemBox));

    var urlBox = document.getElementById("url-box") as HTMLInputElement;
    var urlDecodeButton = document.getElementById("url-decode") as HTMLButtonElement;

    var urlBoxChanged = (e) => {
        if (isUrlMaybe(urlBox.value)) {
            urlDecodeButton.disabled = false;

            if (e.keyCode == 13) {
                decodeUrl(e, urlDecodeButton, urlBox);
            }
        }
        else {
            urlDecodeButton.disabled = true;
        }
    };

    urlBox.addEventListener("keyup", urlBoxChanged);
    urlBox.addEventListener("input", urlBoxChanged);


    urlDecodeButton.addEventListener('click', e => decodeUrl(e, urlDecodeButton, urlBox));

    // Other tools (e.g. the chain visualizer's "View PEM Details" button) can link here with the
    // certificate base64-encoded in #pem= (or ?pem=) and it decodes immediately. The fragment form
    // is preferred because large certificates blow past server URL limits.
    var pageUrl = new URL(window.location.href);
    var pemParam = pageUrl.searchParams.get("pem");
    if (!pemParam && pageUrl.hash.indexOf("#pem=") == 0) {
        pemParam = decodeURIComponent(pageUrl.hash.substring("#pem=".length));
    }
    if (pemParam) {
        try {
            // '+' in a query string decodes as a space; put any back before base64-decoding.
            var linkedPem = atob(pemParam.replace(/ /g, "+"));
            if (isPemFormattedString(linkedPem)) {
                pemBox.value = linkedPem;
                pemDecodeButton.disabled = false;
                decodePem(null, urlDecodeButton, pemBox);
            }
        }
        catch {
            // Not valid base64 — leave the page in its normal empty state.
        }
    }
}
init();

async function decodePem(e: MouseEvent, urlDecodeButton: HTMLButtonElement, pemBox: HTMLTextAreaElement) {
    var response = await fetch(buildFetchUrl("?handler=PemDecode"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            pemText: pemBox.value
        })
    })

    var json = await response.json();

    displayDecodeResult(json);
}

async function decodeUrl(e: MouseEvent, urlDecodeButton: HTMLButtonElement, urlBox: HTMLInputElement) {
    var response = await fetch(buildFetchUrl("?handler=UrlDecode"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            urlText: urlBox.value
        })
    })

    var json = await response.json();

    displayDecodeResult(json);
}

function displayDecodeResult(json) {
    if (!json.success) {
        displayDecodeFailed(json);
        return;
    }

    var startDiv = document.getElementById("start-decode");
    var decodedCertDiv = document.getElementById("decoded-certificate");

    // Smear every json property into an element with the same class name if we can find it.
    Object.keys(json.certificateInfo).forEach(key => {
        var element = decodedCertDiv.querySelector(`.${key}`);

        if (element == null) {
            return;
        }

        element.textContent = json.certificateInfo[key];
    });

    // Touch up some parts that simple smearing doesn't handle
    var sanlistTd = decodedCertDiv.querySelector(".san-list") as HTMLTableCellElement;
    json.certificateInfo.sans.forEach(san => {
        var sanDiv = document.createElement("div");
        sanDiv.innerText = san;
        sanlistTd.appendChild(sanDiv);
    });

    var timeToExpiryDaysSpan = decodedCertDiv.querySelector('.timeToExpiryDays');
    timeToExpiryDaysSpan.parentElement.className = json.certificateInfo.expiryColorClass;

    var crtShSha256Link = document.querySelector(".sha256").parentElement.querySelector("a");
    crtShSha256Link.href = crtShSha256Link.href.replace("HASH_GOES_HERE", json.certificateInfo.sha256);

    var crtShSerialNumberLink = document.querySelector(".serialNumber").parentElement.querySelector("a");
    crtShSerialNumberLink.href = crtShSerialNumberLink.href.replace("SERIAL_GOES_HERE", json.certificateInfo.serialNumber);

    // Show Cert info
    startDiv.style.display = "none";
    decodedCertDiv.style.display = "block";
}

function displayDecodeFailed(json) {
    var startDiv = document.getElementById("start-decode");
    var decodeFailedDiv = document.getElementById("decode-failed");

    var messagePre = decodeFailedDiv.querySelector(".message") as HTMLPreElement;
    messagePre.innerText = json.message;

    startDiv.style.display = "none";
    decodeFailedDiv.style.display = "block";
}

function isPemFormattedString(str) {
    const pemRegex = /-----BEGIN CERTIFICATE-----\s*([A-Za-z0-9+/=\r\n]+?)\s*-----END CERTIFICATE-----/;
    return pemRegex.test(str);
}

function isUrlMaybe(str) {
    try {
        if (!str.startsWith("http")) {
            str = "https://" + str;
        }
        var uri = new URL(str);
        return true;
    }
    catch {
        return false;
    }
}
